import { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/lib/context/LanguageContext';

export function LanguageSwitcher() {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (langCode: 'fr' | 'en' | 'ht') => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        className="flex items-center text-white hover:bg-primary-dark rounded-full p-2 focus:outline-none"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
      >
        <Globe className="h-5 w-5" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 ring-1 ring-black ring-opacity-5">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={`${
                currentLanguage === language.code
                  ? 'bg-gray-100 text-primary'
                  : 'text-gray-700 hover:bg-gray-50'
              } block w-full text-left px-4 py-2 text-sm`}
            >
              {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}